const lang = {
  intro: {
    title: "Explore The World of Dining (US)",
    paragraph:
      "<p>As dining returns around the world, we’ve curated a set of global restaurants as part of the complimentary Dining Credit we’re providing from now until 31st December, 2021. Whether it’s going al fresco at a local restaurant or discovering new cuisines abroad, we’ve selected over 2000+ restaurants in %COUNT% countries for you to explore.</p>",
    tcLink:
      'View full dining benefit details and T&Cs',
    hotelRestaurant:
      "* Please note that if you’re staying in a hotel, this credit will be applied only when settling the restaurant bill directly with the restaurant, separate from the overall hotel payment.",
  },
  filters: {
    country: "Country:",
    state: "State:",
    stateDefault: "All states",
    city: "City:",
    cityDefault: "All cities",
    cuisine: "Cuisine:",
    cuisineDefault: "All cuisines",
  },
  results: {
    halal: "Halal",
    notAvailable: "Restaurants not available for this selection",
    viewmap: "View on map",
    makebooking: "Make a booking:",
    makebookingTel: "To make a booking please call:",
    orderOnline: "To order please visit:",
    deliveryTakeaway: "Delivery/Take-Away available",
    deliveryProvidoor: "Delivery available via Providoor",
    openingSoon: "Opening soon",
    onlineOnly: "Online Only",
    new: "NEW",
    locations: "locations",
    button: "View locations",
    groupCuisine: "Various cuisines",
    close: "close",
    bookNow: "Book now",
  },
  pocket: {
    title: "Explore 800+ restaurants and book directly with Pocket Concierge",
    button: "Visit Pocket Concierge",
  },
  pocketCard: {
    title: "Pocket Concierge",
    description:
      "Discover and book the best restaurants in Japan (only restaurants accepted prepaid are eligible)",
    cuisines: "Various cuisines",
    instruction: "Make a booking:",
    button: "Visit Pocket Concierge",
  },
  footer: {
    disclaimer:
      "<p>For full offer details, please refer to the marketing email communication you received [market to insert email title].</p><p><a href='https://www.americanexpress.com/us/privacy-center/'>Privacy Center</a></p><p>Copyright © 2023 American Express Company</p>",
  },
};

export default lang;
